module.exports = __webpack_public_path__ + "img/colors.8ada24e9.webp";